document.addEventListener('DOMContentLoaded', function() {
  const swiper = new Swiper('.mySwiper', {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 0,
    direction: "horizontal",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    simulateTouch: false,
    touchRatio: 0, 
  });
  
  document.querySelector('.title-pagination-item[data-index="0"]').classList.add('active');

  document.querySelectorAll('.title-pagination-item').forEach((item, index) => {
      item.addEventListener('click', (e) => {
          e.preventDefault(); 
          swiper.slideTo(index);
          document.querySelectorAll('.title-pagination-item').forEach(i => i.classList.remove('active'));
          item.classList.add('active');
          updatePaginationColor(index);
      });
  });

  swiper.on('slideChange', () => {
      const activeIndex = swiper.activeIndex;
      document.querySelectorAll('.title-pagination-item').forEach(i => i.classList.remove('active'));
      document.querySelector(`.title-pagination-item[data-index="${activeIndex}"]`).classList.add('active');
      updatePaginationColor(activeIndex);
  });

  function updatePaginationColor(index) {
      const currentSlide = document.querySelector(`.swiper-slide.slide-${index + 1}`);
      const highlightTextColor = getComputedStyle(currentSlide).getPropertyValue('--highlight-text-color');
      document.querySelector('.titles-pagination').style.color = highlightTextColor;
  }
});